export default "__VITE_ASSET__BI34_$KW__"